define('catalogsMainRouter',[
  'module',
  'require',
  'marionette',
  'app',
  'underscore',
  'settings',
  'contentShowController',
  'itemPagesNameMixin'
], function (
  Module,
  require,
  Marionette,
  App,
  _,
  Settings,
  ContentShowController,
  ItemPagesNameMixin
) {
  'use strict';

  var Router = Marionette.AppRouter.extend({
    appRoutes: {
      'products/catalogs': 'showCatalogsList'
      // Detail route can be added later if needed
    }
  });

  var API = {
    showCatalogsList: function () {
      require([
        'catalogsListView',
        'catalogEntities'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = App.getCurrentRoute();
          Settings.set('currentView', 'catalogsList', true);
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.PRODUCTS_CATALOGS);
        });
      });
    }
  };

  App.on('before:start', function () {
    new Router({controller: API});
  });
});

